import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const ClassDetailsIndex = React.lazy(
	() =>
		import(
			/* webpackChunkName : 'ClassDetailsIndex' */ './components/ClassDetailsIndex'
		)
);

export default (store) => {
	return {
		index: true,
		element: <AsyncLoading component={<ClassDetailsIndex />} />,
	};
};
